import { apiSlice } from '../../api-slice';

const baseUrl = `${process.env.REACT_APP_APPLICATIONS_MANAGER_API_URL}/uploading-data`;

export const uploadingDataApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getExternalsPageable: builder.query({
      query: ({ page, size, request }) => ({
        url: `${baseUrl}/external-entities/all-pageable`,
        method: 'POST',
        body: request,
        params: {
          page,
          size,
        },
      }),
    }),
    getExternalById: builder.query({
      query: ({ id, type }) => ({
        url: `${baseUrl}/external-entities/${id}?type=${type}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetExternalsPageableQuery, useGetExternalByIdQuery } =
  uploadingDataApi;
